// EmailCampaingning.jsx
import { Button, Dropdown, Modal, Nav, Table } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { WhatsappModal } from "../campaigningComponents/WhatsappModal"
import { useEffect, useState } from "react";
import {
  DeleteRequest,
  GetRequest,
  PostRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faEllipsisVertical,
  faEye,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import DeleteModal from "../DeleteModal";
import { toast } from "sonner";
import {
  getAllCities,
  getAllStates,
  getCountries,
} from "../../Utils/hooks/location";
import { Controller, Form, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { MyEditor } from "../../Utils/helpers/MyEditor";
import { CampaigningFilter } from "./CampaigningFilter";
import { baseURL } from "../../Utils/constants/constant";

//schemas for email template
const emailSchema = z.object({
  module_name: z.string().min(1, "campaign name is required"),
  subject: z.string().min(1, "subject is required"),
  body: z.string().min(1, "body is required"),
  image: z.instanceof(FileList),
});

export const WhatsAppCampainging = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [campaignName, setCampaignName] = useState("");
  const [updateCampaignId, setUpdateCampaignId] = useState(null);
  const [description, setDescription] = useState("");
  // button loading for sending email
  const [buttonLoading, setButtonLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("leads");
  const [listTableData, setListTableData] = useState([]);
  const [tabData, setTabData] = useState([]);
  // state for selecting filterquery without clicking on card
  const [filterQueryValues, setFilterQueryValues] = useState([]);
  //refetch tab data
  const [refetchTabData, setRefetchTabData] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [customer, setCustomer] = useLocalStorageState("customer");
  const customerId = customer?.customer_details?.customer_id;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const headers = {
    authentication: rf,
    Authorization: token,
  };
  const extras = { customer, setCustomer, rf, navigate };

  // parse values for filter query
  const [filterQueryValue, setFilterQueryValue] = useState([]);
  //parse data state for filter
  const [parsedFilterData, setParsedFilterData] = useState(null);
  // lead source state
  const [lead_source, setLeadSource] = useState([]);
  // state for companies
  const [company, setCompany] = useState([]);
  // state for filter dropdown contacts
  const [filterDropdown, setFilterDropdown] = useState(false);
  // states to store the filter data
  const [filterStates, setFilterState] = useState([]);
  // filter state to see the temoporary applied filter data,
  const [tempFilterData, setTempFilterData] = useState(null);
  // lead owner state
  const [leadOwner, setLeadOwner] = useState([
    {
      leadName: "",
      leadId: "",
    },
  ]);
  // country state
  const [country, setCountries] = useState([]);
  // all states for filter field hydration
  const [allState, setAllState] = useState([]);
  // all cities for filter field hydration
  const [allCity, setAllCity] = useState([]);
  //dropdown state
  const [dropdownOptions, setDropdownOptions] = useState([]);
  // loading state for delete
  const [isLoading, setIsLoading] = useState(false)


  // Determine the data to display based on filterData
  const dataToDisplay = tempFilterData !== null ? tempFilterData : tabData;
  const hasDataToDisplay = dataToDisplay?.length > 0;

  const industryOptions = [
    { value: "Technology", label: "Technology" },
    { value: "Healthcare", label: "Healthcare" },
    { value: "Finance", label: "Finance" },
    { value: "Education", label: "Education" },
    { value: "Manufacturing", label: "Manufacturing" },
    { value: "Retail", label: "Retail" },
    { value: "Real Estate", label: "Real Estate" },
    { value: "Construction", label: "Construction" },
    { value: "Transportation", label: "Transportation" },
    { value: "Food & Beverage", label: "Food & Beverage" },
    { value: "Entertainment", label: "Entertainment" },
    { value: "Consulting", label: "Consulting" },
    { value: "Marketing & Advertising", label: "Marketing & Advertising" },
    { value: "Legal Services", label: "Legal Services" },
    { value: "Insurance", label: "Insurance" },
    { value: "Telecommunications", label: "Telecommunications" },
    { value: "Energy", label: "Energy" },
    { value: "Agriculture", label: "Agriculture" },
    { value: "Automotive", label: "Automotive" },
    { value: "Aerospace", label: "Aerospace" },
    { value: "Pharmaceuticals", label: "Pharmaceuticals" },
    { value: "Banking", label: "Banking" },
    { value: "E-commerce", label: "E-commerce" },
    { value: "Media", label: "Media" },
    { value: "Non-profit", label: "Non-profit" },
    { value: "Government", label: "Government" },
    { value: "Hospitality", label: "Hospitality" },
    { value: "Travel & Tourism", label: "Travel & Tourism" },
    { value: "Sports & Recreation", label: "Sports & Recreation" },
    { value: "Beauty & Wellness", label: "Beauty & Wellness" },
  ];


  const businessTypeOptions = [
    { value: "Sole Proprietorship", label: "Sole Proprietorship" },
    { value: "Limited Liability Partnership(LLP)", label: "Limited Liability Partnership(LLP)" },
    { value: "Private Limited Company", label: "Private Limited Company" },
    { value: "Public Limited Company", label: "Public Limited Company" },
  ]

  const employeeSizeOptions = [
    { value: '1-10', label: '1-10' },
    { value: '11-50', label: '11-50' },
    { value: '51-200', label: '51-200' },
    { value: '201-500', label: '201-500' },
    { value: '501-1000', label: '501-1000' },
    { value: '1001+', label: '1001+' }
  ];
  // filter dropdown options for contact
  const contactDropdownOptions = [
    { value: "first_name", label: "First Name" },
    { value: "last_name", label: "Last Name" },
    { value: "email", label: "Email" },
    { value: "phone", label: "Phone" },
    { value: "owner_id", label: "Owner", option: leadOwner },
    { value: "report_to", label: "Report To" },
    { value: "visible_to", label: "Visible To", option: leadOwner },
    { value: "company_id", label: "Company Name", option: company },
    { value: "designation", label: "Designation" },
    { value: "department", label: "Department" },
    { value: "decision_maker", label: "Decision Maker" },
    { value: "city", label: "City", option: allCity },
    { value: "state", label: "State", option: allState },
    { value: "country", label: "Country", option: country },
    { value: "zipcode", label: "Zipcode" },
    { value: "lead_source_id", label: "Lead Source", option: lead_source },
    { value: "tag", label: "Tags" },
    { value: "note", label: "Notes" },
  ];

  //filter dropdowndown options for company
  const companyDropdownOptions = [
    { value: "company_name", label: "Company Name" },
    { value: "website", label: "Website" },
    { value: "industry", label: "Industry", option: industryOptions },
    { value: "business_type", label: "Business Type", option: businessTypeOptions },
    { value: "employee_size", label: "Employee Size", option: employeeSizeOptions },
    { value: "owner_id", label: "Owner", option: leadOwner },
    { value: "email", label: "Email" },
    { value: "phone", label: "Phone" },
    { value: "address", label: "Address" },
    { value: "city", label: "City", option: allCity },
    { value: "state", label: "State", option: allState },
    { value: "country", label: "Country", option: country },
    { value: "zipcode", label: "Zipcode" },
    { value: "about", label: "About" },
    { value: "rating", label: "Rating" },
  ];

  // FIXED: Added proper filter dropdown options for leads (was empty before)
  const leadsDropdownOptions = [
    { value: "first_name", label: "First Name" },
    { value: "last_name", label: "Last Name" },
    { value: "email", label: "Email" },
    { value: "phone", label: "Phone" },
    { value: "owner_id", label: "Owner", option: leadOwner },
    { value: "company_id", label: "Company Name", option: company },
    { value: "designation", label: "Designation" },
    { value: "department", label: "Department" },
    { value: "city", label: "City", option: allCity },
    { value: "state", label: "State", option: allState },
    { value: "country", label: "Country", option: country },
    { value: "zipcode", label: "Zipcode" },
    { value: "lead_source_id", label: "Lead Source", option: lead_source },
    { value: "status", label: "Status" },
    { value: "priority", label: "Priority" },
    { value: "tag", label: "Tags" },
    { value: "note", label: "Notes" },
  ];

  // sub filter dropdown option
  const subFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "contains", label: "Contains" },
    { value: "not_contains", label: "Not-Contains" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
    { value: "is_empty", label: "Is Empty" },
    { value: "is_not_empty", label: "Is Not Empty" },
    { value: "begins_with", label: "Begins With" },
  ];

  const customSubFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "is_set", label: "Is Set" },
    { value: "is_not_set", label: "Is Not Set" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
  ];



  const {
    register,
    handleSubmit,
    control, // <-- this is the one you use
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(emailSchema),
    defaultValues: {
      body: "",
      status: "Active",
    },
  });

  // FIXED: Added function to get appropriate dropdown options
  const getDropdownOptions = () => {
    if (selectedTab === "leads") return leadsDropdownOptions;
    if (selectedTab === "company") return companyDropdownOptions;
    if (selectedTab === "contact") return contactDropdownOptions;
    return [];
  };

  // FIXED: Initialize dropdown options on component mount and when dependencies change
  useEffect(() => {
    setDropdownOptions(getDropdownOptions());
  }, [
    selectedTab,
    leadOwner,
    company,
    allCity,
    allState,
    country,
    lead_source,
  ]);

  // useeffect for companies
  useEffect(() => {
    (async () => {
      const res = await GetRequest(
        `company/fetchCompanies/${customer.customer_details.customer_id}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      );
      if (!res) return;
      if (res.success === false) {
        toast.error(res.msg);
        return;
      }
      setCompany(
        res.data.map((c) => ({
          company_name: c.company_name,
          company_id: c.id,
        }))
      );
    })();
  }, []);

  // useeffect for lead source
  useEffect(() => {
    (async () => {
      const res = await GetRequest(
        `masters/getAllLead_source/${customer.customer_details?.customer_id}`,
        { headers },
        extras
      );
      if (!res) return;
      if (res.success === false) {
        toast.error(res.msg);
        return;
      }
      setLeadSource(
        res.data.map((lead) => ({
          source_title: lead.source_title,
          lead_source_id: lead.id,
        }))
      );
    })();
  }, []);

  //  allFstate for filter hydration
  useEffect(() => {
    (async () => {
      try {
        const data = await getAllStates();
        if (!data || data === undefined) {
          setAllState([]);
          return;
        }
        // Update state once with all country data
        setAllState(
          data.map((state) => ({
            stateName: state.state_name,
            stateCode: state.id,
          }))
        );
      } catch (error) {
        toast.error("Error Fetching State");
        return;
      }
    })();
  }, []);

  // allcity useeffect for filter hydration
  useEffect(() => {
    (async () => {
      try {
        const data = await getAllCities();
        if (!data || data === undefined) {
          setAllCity([]);
          return;
        }
        //Update state once with all country data
        setAllCity(
          data.map((city) => ({
            cityName: city.city_name,
            cityCode: city.id,
          }))
        );
      } catch (error) {
        toast.error("Error Fetching State");
        return;
      }
    })();
  }, []);

  // useeffect for country
  useEffect(() => {
    (async () => {
      try {
        const data = await getCountries();
        if (!data) return;
        // Update state once with all country data
        setCountries(
          data.map((country) => ({
            countryName: country.name,
            countryId: country.id,
          }))
        );
      } catch (error) {
        toast.error("Error Fetching Data");
        return;
      }
    })();
  }, []);

  // useeffect for fetching users for lead_owners, visible_to, report_to
  useEffect(() => {
    (async () => {
      const res = await GetRequest(
        `users/users/fetchUserAsOwner/${customer.customer_details.customer_id}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      );
      if (res.err) {
        toast.error("Error Fetching Data");
      }
      const owners =
        res.data &&
        res.data.map((lead) => ({
          leadName: lead.full_name,
          leadId: lead.id,
        }));
      setLeadOwner(owners);
    })();
  }, []);

  // parsed data
  useEffect(() => {
    if (parsedFilterData && parsedFilterData.filter_data?.[0]?.filter_values) {
      const values = parsedFilterData.filter_data[0].filter_values;
      const parsedState = JSON.parse(values);
      // set filter query value to pass in payload in the send email template form
      setFilterQueryValue(parsedState);
      const filteredArray = parsedState?.map((state) => {
        // Find the corresponding dropdown option to get the display label and potential nested options
        const dropdownOption = dropdownOptions.find(
          (opt) => opt.value === state.label_name
        );
        const dropdownQuery = "";
        let mappedOptions = null;
        if (dropdownOption?.option && Array.isArray(dropdownOption.option)) {
          // Replicate the mapping logic from handleAddFilter
          if (dropdownOption.value === "owner") {
            mappedOptions = dropdownOption.option.map((opt) => ({
              value: opt.leadId,
              label: opt.leadName,
            }));
          }
          else if (dropdownOption.value === "lead_source_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.lead_source_id,
              label: opt.source_title,
            }));
          } else if (dropdownOption.value === "company_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.company_id,
              label: opt.company_name,
            }));
          } else if (dropdownOption.value === "country") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.countryId,
              label: opt.countryName,
            }));
          } else if (dropdownOption.value === "state") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.stateCode,
              label: opt.stateName,
            }));
          } else if (dropdownOption.value === "city") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.cityId,
              label: opt.cityName,
            }));
          } else if (dropdownOption.value === "industry") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.value,
              label: opt.label,
            }));
          } else if (dropdownOption.value === "business_type") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.value,
              label: opt.label,
            }));
          } else if (dropdownOption.value === "employee_size") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.value,
              label: opt.label,
            }));
          }
        }

        return {
          id: state.label_name, // IMPORTANT: Generate a new unique ID for React keys
          field: state.label_name, // This is the internal identifier (e.g., "email", "owner")
          label_name: dropdownOption ? dropdownOption.label : state.label_name,
          option: mappedOptions,
          subFilterType: state.label_query,
          value: state.label_value,
        };
      });
      setFilterState(filteredArray);
    }
  }, [parsedFilterData, dropdownOptions]);

  // Fetch tab cards
  const fetchTabData = async () => {
    try {
      setLoading(true);
      const res = await GetRequest(
        `/common/fetchFilterCard/${customerId}/${selectedTab}`,
        { headers },
        extras
      );
      if (res && res.data) {
        setTabData(res.data);
      }
    } catch (err) {
      console.error("Tab fetch error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTabData();
    return () => {
      setTabData([]);
      setListTableData([]);
    };
  }, [selectedTab, refetchTabData]);

  //fetch tab list data
  const handleListData = async (id) => {
    let endpoint = "";
    if (selectedTab === "leads")
      endpoint = `/lead/fetchLeads/${customerId}/${id}/${customer?.customer_details?.id}`;
    else if (selectedTab === "contact")
      endpoint = `contacts/fetchAllContacts/${customerId}/${id}`;
    else if (selectedTab === "company")
      endpoint = `company/fetchAllCompanies/${customerId}/${id}`;

    if (!endpoint) return;

    const res = await GetRequest(endpoint, { headers }, extras);
    setListTableData(res.data || []);
    res.data && setParsedFilterData(res);
  };

  // edit list name
  const editCampaignName = async () => {
    const payload = {
      customer_id: customerId,
      card_name: campaignName,
      description: description,
      filter_id: updateCampaignId,
    };
    try {
      const res = await PutRequest(
        `${baseURL}contacts/updateFilterName`,
        payload,
        { headers },
        extras
      );
      if (res.status === "success") {
        toast.success(res.message || "campaign name updated successfully");
        // trigger refetch
        await fetchTabData();
        setShowModal(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // delete list from module
  const deleteItemById = async () => {
    if (!deleteItemId) return;
    setIsLoading(true)
    try {
      const res = await DeleteRequest(
        `${baseURL}contacts/deleteFilter/${deleteItemId}`,
        { headers },
        extras
      );
      setTabData((prev) => prev.filter((item) => item.id !== deleteItemId));
      setListTableData([]);
      setIsLoading(false)
      toast.success(res.message || "Item deleted successfully");
    } catch (err) {
      toast.error(err.message || "Failed to delete");
      setIsLoading(false)
    } finally {
      setShowDeleteModal(false);
      setDeleteItemId(null);
      setFilterDropdown(false);
      setTempFilterData(null);
      setIsLoading(false)
      setFilterState([]); // Clear filter states
      setFilterQueryValues([]); // Clear filter query values
      setFilterQueryValue([]); // Clear parsed filter values
      setParsedFilterData(null); // Clear parsed data
    }
  };

  //css classes
  const containerStyle = {
    display: "flex",
    flexWrap: "wrap",
    alignContent: "flex-start",
    height: "180px", // 3 rows * 60px height each
    overflow: "auto", // optional
  };

  const itemStyle = {
    width: "200px", // width of each column
    height: "60px", // height of each row
    margin: "5px",
    border: "1px solid #ccc",
    backgroundColor: "#f8f9fa",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "4px",
  };

  //useEffect for ck editor
  useEffect(() => {
    // Register the field manually on mount
    register("body", { required: "Body is required" });
  }, [register]);


  // submit function for right side form
  const on = async (data) => {
    if (filterQueryValue?.length === 0 && filterQueryValues?.length === 0) {
      return toast.error("select filter");
    }
    if (listTableData.length === 0) {
      return toast.error("No data for the selected filter")

    }
    const payload = {
      filter_query: (filterQueryValue.length > 0
        ? filterQueryValue
        : filterQueryValues
      ).map((f) => ({
        label_name: f.label_name,
        label_query: f.label_query,
        label_value: f.label_value,
      })),
      customer_id: customerId,
      subject: data.subject,
      body: data.body,
      campaign_name: data.module_name,
      module_name: selectedTab,
      user_login_id: "5",
      email_document: data.image[0] ? data.image[0] : "",
      // image: data.image
    };
    setButtonLoading(true);
    const res = await PostRequest(
      `${baseURL}Campaiging/sendMail`,
      payload,
      true,
      { headers },
      extras
    );
    if (res.status === "success") {
      setButtonLoading(false);
      toast.success(res.message || "email sent successfully");

      // toast.error("please provide filter values")
      // setButtonLoading(false)
    } else {
      setButtonLoading(false);
      toast.error("error sending in email");
    }
  };

  const renderTabList = () => {
    return tabData?.map((item) => (
      <li
        style={itemStyle}
        className="itemStyle border gap-2 p-2 rounded align-items-center"
        key={item.id}
      >
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            setTempFilterData(null);
            handleListData(item.id);
          }}
        >
          {item.card_name}
        </span>
        <Dropdown as="div" className="dropdownsWithoutToggle">
          <Dropdown.Toggle as={Nav.Link} className="header-link">
            <button className="py-2 w-[30px] btn btn-light">
              <FontAwesomeIcon icon={faEllipsisVertical} />
            </button>
          </Dropdown.Toggle>
          <Dropdown.Menu
            className="defaultDropdown dropdown-menu-end"
            style={{ minWidth: "10rem" }}
          >
            <Dropdown.Item onClick={() => handleListData(item.id)}>
              <FontAwesomeIcon icon={faEye} className="me-2 text-secondary" />
              View
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setCampaignName(item.card_name);
                setUpdateCampaignId(item.id);
                setDescription(item.description);
                setShowModal(true);
              }}
            >
              <FontAwesomeIcon icon={faEdit} className="me-2 text-secondary" />
              Edit
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setDeleteItemId(item.id);
                setShowDeleteModal(true);
              }}
            >
              <FontAwesomeIcon icon={faTrash} className="me-2 text-secondary" />
              Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </li>
    ));
  };

  return (
    <div className="w-100 h-100 px-3">
      <div className="d-flex justify-content-between w-100">
        <div className="d-flex gap-2 align-items-center">
          <i
            className="fab fa-whatsapp text-white border bg-green px-2 pt-2 pb-1 rounded-1"
            style={{ fontSize: "30px" }}
          ></i>
          <div className="mt-1">
            <h5 className="mb-0">WhatsApp Campaign</h5>
            <small className="text-muted">
              View Email Campaign while adding/editing Campaign.
            </small>
          </div>
        </div>
        <Button
          className="bg-primary text-white px-3"
          style={{ height: "2.5rem" }}
        >
          History
        </Button>
      </div>
      <div className="d-flex w-100 h-100 mt-5">
        {/* Left panel */}
        <div className="d-flex flex-column gap-3 w-75 px-2">
          <div className="d-flex flex-column bg-white p-3 shadow rounded-2">
            <div className="d-flex justify-content-between">
              <span className="fw-bold">Select Target</span>
              <div className="d-flex gap-3">
                {["leads", "company", "contact"].map((tab) => (
                  <label key={tab} className="d-flex align-items-center gap-1">
                    <input
                      type="radio"
                      name="tab"
                      value={tab}
                      checked={selectedTab === tab}
                      onChange={() => {
                        // FIXED: Proper state reset when switching tabs
                        setFilterDropdown(false);
                        setTempFilterData(null);
                        setSelectedTab(tab);
                        setFilterState([]); // Clear filter states
                        setFilterQueryValues([]); // Clear filter query values
                        setFilterQueryValue([]); // Clear parsed filter values
                        setParsedFilterData(null); // Clear parsed data

                        // Set appropriate dropdown options
                        if (tab === "leads") {
                          setDropdownOptions(leadsDropdownOptions);
                        } else if (tab === "company") {
                          setDropdownOptions(companyDropdownOptions);
                        } else if (tab === "contact") {
                          setDropdownOptions(contactDropdownOptions);
                        }
                      }}
                    />
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </label>
                ))}
                <CampaigningFilter
                  currentTab={selectedTab}
                  filterDropdown={filterDropdown}
                  setFilterDropdown={setFilterDropdown}
                  dropdownOptions={dropdownOptions}
                  filterState={filterStates}
                  setFilterState={setFilterState}
                  subFilter={subFilter}
                  customSubFilter={customSubFilter}
                  setTempFilterData={setTempFilterData}
                  setRefetchTabData={setRefetchTabData}
                  refetchTabData={refetchTabData}
                  setFilterQueryValues={setFilterQueryValues}
                  filterQueryValues={filterQueryValues}
                ></CampaigningFilter>
              </div>
            </div>
            <hr />
            {loading ? (
              <div className="text-center">
                <div className="spinner-border text-secondary" />
              </div>
            ) : (
              <div style={containerStyle}>{renderTabList()}</div>
            )}
          </div>
          <div className="bg-white p-3 shadow rounded-2">
            <span className="fw-bold">Admission Campaign</span>
            <hr />
            <Table striped>
              <thead>
                <tr>
                  <th>#</th>
                  <th>NAME</th>
                  <th>EMAIL</th>
                  <th>PHONE NO.</th>
                  {selectedTab === "contact" && (
                    <>
                      <th>SOURCE</th>
                      <th>LEAD OWNER</th>
                    </>
                  )}
                  {selectedTab === "company" && <th>Ratings</th>}
                  {selectedTab === "leads" && (
                    <>
                      <th>STATUS</th>
                      <th>LEAD OWNER</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {tempFilterData === null ? (
                  listTableData?.length ? (
                    listTableData.map((item, i) => (
                      <tr key={item.id || i}>
                        <td>{i + 1}</td>
                        <td>{item.first_name || item.company_name || "N/A"}</td>
                        <td>{item.email}</td>
                        <td>{item.phone}</td>
                        {selectedTab === "contact" && (
                          <>
                            <td>{item.source_title}</td>
                            <td>{item.owner_name}</td>
                          </>
                        )}
                        {selectedTab === "company" && <td>{item.rating}</td>}
                        {selectedTab === "leads" && (
                          <>
                            <td>{item.status}</td>
                            <td>{item.owner_name}</td>
                          </>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      {" "}
                      <td className="text-center" colSpan={100}>
                        No data found
                      </td>
                    </tr>
                  )
                ) : tempFilterData?.length ? (
                  tempFilterData.map((item, i) => (
                    <tr key={item.id || i}>
                      <td>{i + 1}</td>
                      <td>{item.first_name || item.company_name || "N/A"}</td>
                      <td>{item.email}</td>
                      <td>{item.phone}</td>
                      {selectedTab === "contact" && (
                        <>
                          <td>{item.source_title}</td>
                          <td>{item.owner_name}</td>
                        </>
                      )}
                      {selectedTab === "company" && <td>{item.rating}</td>}
                      {selectedTab === "leads" && (
                        <>
                          <td>{item.status}</td>
                          <td>{item.owner_name}</td>
                        </>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    {" "}
                    <td className="text-center" colSpan={100}>
                      No filter data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        {/* Right panel */}
        <div className="w-25 bg-white shadow rounded-2 p-3 mb-3">

          <WhatsappModal currentTab={selectedTab}
            filterQueryValue={filterQueryValue}
            setFilterQueryValue={setFilterQueryValue}
            filterQueryValues={filterQueryValues}
            setfilterQueryValues={setFilterQueryValues}

          />
        </div>
      </div>
      {/* Delete Modal */}
      {showDeleteModal && (
        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={deleteItemById}
          isLoading={isLoading}
          message="Are you sure you want to permanently delete this item?"
        />
      )}
      {/* update modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Campaign</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label>
            Enter campaign name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter campaign name"
            value={campaignName}
            onChange={(e) => setCampaignName(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={editCampaignName}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
